import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_API_URL } from '../../app/config';

@Injectable()
export class UserProvider {
  constructor(public httpClient: HttpClient) {}

  list() {
    return this.httpClient.get(`${SERVER_API_URL}/users`);
  }

  add(data: any) {
    return this.httpClient.post(`${SERVER_API_URL}/user`, data, { responseType: 'json' });
  }

  edit(data: any) {
    return this.httpClient.put(`${SERVER_API_URL}/user`, data, { responseType: 'json' });
  }

  delete(id: string) {
    return this.httpClient.delete(`${SERVER_API_URL}/user/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts